import { render, staticRenderFns } from "./WebsiteManagement.vue?vue&type=template&id=69f3c4c7&scoped=true&"
import script from "./WebsiteManagement.vue?vue&type=script&lang=js&"
export * from "./WebsiteManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f3c4c7",
  null
  
)

component.options.__file = "WebsiteManagement.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VApp,
  VContainer,
  VLayout,
  VSpacer,
})
